export interface ErrorDetails {
  errorCode: number | string;
  errorMessage: string;
}

export const ERROR_DETAILS_MAP: Record<string, ErrorDetails> = {
  pa_missing_token: {
    errorCode: '400',
    errorMessage: "We couldn't verify your login request securely. Please try logging in again.",
  },
  pa_invalid_token: {
    errorCode: '400',
    errorMessage:
      'Your login session could not be verified or has expired. For your security, please restart the login process.',
  },
  pa_missing_app_name: {
    errorCode: '400',
    errorMessage: 'An application configuration error prevented your login. Please contact support.',
  },
  pa_missing_state_key: {
    errorCode: '400',
    errorMessage:
      'We lost connection to your secure session. Please return to the application and try logging in again.',
  },
  pa_session_not_found: {
    errorCode: '400',
    errorMessage:
      'Your secure onboarding session has expired due to inactivity. Please restart your login to continue.',
  },
  pa_missing_redirect_url: {
    errorCode: '400',
    errorMessage: 'An application configuration error prevented your login. Please contact support.',
  },
  sp_app_access_denied: {
    errorCode: '403',
    errorMessage:
      "Seems you don't have access to this app or user mapping is missing, try refreshing user screen or contact your admin",
  },
};

export const getErrorDetails = (error: string | null): ErrorDetails => {
  if (!error) return { errorCode: '', errorMessage: '' };
  return (
    ERROR_DETAILS_MAP[error] || {
      errorCode: '400',
      errorMessage: `Error: ${error}`,
    }
  );
};
